import { useEffect, useState } from "react";
import axios from "axios";
import { format } from "date-fns";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Admin() {
  const [enquiries, setEnquiries] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    try {
      const { data } = await axios.get(`${API}/enquiries`);
      setEnquiries(data);
    } catch (e) {
      setEnquiries([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, []);

  const setStatus = async (id, status) => {
    await axios.patch(`${API}/enquiries/${id}?status=${status}`);
    load();
  };

  return (
    <div className="min-h-screen bg-bg text-ink px-6 md:px-12 py-16">
      <div className="mx-auto max-w-[1400px]">
        <div className="flex items-end justify-between border-b border-white/10 pb-8">
          <div>
            <span className="font-sans text-xs tracking-[0.25em] uppercase text-gold">
              Admin
            </span>
            <h1 className="mt-3 font-serif font-light text-4xl md:text-5xl">
              Booking Enquiries
            </h1>
          </div>
          <span className="font-sans text-sm text-ash" data-testid="enquiry-count">
            {enquiries.length} total
          </span>
        </div>

        {loading ? (
          <p className="mt-10 font-sans text-ash">Loading…</p>
        ) : enquiries.length === 0 ? (
          <p className="mt-10 font-sans text-ash">No enquiries yet.</p>
        ) : (
          <div className="mt-10 space-y-4" data-testid="enquiry-list">
            {enquiries.map((e) => (
              <div
                key={e.id}
                data-testid={`enquiry-${e.id}`}
                className="bg-surface border border-white/10 p-6 md:p-8 grid grid-cols-1 md:grid-cols-12 gap-6"
              >
                <div className="md:col-span-3">
                  <p className="font-serif text-2xl">{e.name}</p>
                  <a href={`mailto:${e.email}`} className="font-sans text-sm text-gold hover:underline">
                    {e.email}
                  </a>
                  {e.phone && <p className="font-sans text-sm text-ash mt-1">{e.phone}</p>}
                </div>
                <div className="md:col-span-3">
                  <p className="font-sans text-[0.65rem] tracking-[0.2em] uppercase text-ash">Service</p>
                  <p className="font-sans text-sm mt-1">{e.service}</p>
                  {e.guests && <p className="font-sans text-sm text-ash mt-1">Guests: {e.guests}</p>}
                  {(e.arrival || e.departure) && (
                    <p className="font-sans text-sm text-ash mt-1">
                      {e.arrival || "?"} → {e.departure || "?"}
                    </p>
                  )}
                </div>
                <div className="md:col-span-4">
                  <p className="font-sans text-[0.65rem] tracking-[0.2em] uppercase text-ash">Message</p>
                  <p className="font-sans text-sm mt-1 text-ink/70">{e.message || "—"}</p>
                  <p className="font-sans text-xs text-faint mt-3">
                    {format(new Date(e.created_at), "d LLL yyyy, HH:mm")}
                  </p>
                </div>
                <div className="md:col-span-2 flex md:flex-col gap-2 items-start">
                  <span className={`font-sans text-xs px-3 py-1 rounded-full border ${e.status === "new" ? "border-gold text-gold" : "border-white/20 text-ash"}`}>
                    {e.status}
                  </span>
                  <div className="flex gap-2 flex-wrap">
                    <button onClick={() => setStatus(e.id, "contacted")} className="font-sans text-xs text-ash hover:text-ink underline">
                      Mark contacted
                    </button>
                    <button onClick={() => setStatus(e.id, "closed")} className="font-sans text-xs text-ash hover:text-ink underline">
                      Close
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
